import React from 'react';

export const BerryLogo = () => (
  <svg viewBox="0 0 251 251" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.8409 61.4912C80.7622 44.5699 107.964 44.195 125.341 60.3665C142.718 44.2041 169.913 44.582 186.831 61.5002C203.75 78.4188 204.127 105.615 187.963 122.992C188.372 123.371 188.775 123.759 189.172 124.157C206.477 141.462 206.477 169.518 189.172 186.823C171.868 204.127 143.811 204.127 126.507 186.823C126.109 186.425 125.72 186.021 125.34 185.612C124.958 186.024 124.566 186.431 124.165 186.832C106.861 204.136 78.8043 204.136 61.4996 186.832C44.195 169.527 44.195 141.471 61.4996 124.166C61.9 123.766 62.3061 123.375 62.7176 122.993C46.5447 105.616 46.9191 78.4129 63.8409 61.4912ZM125.289 125.33L125.332 125.377L125.374 125.331L125.331 125.291L125.289 125.33ZM105.613 80.0542C112.663 87.1043 112.663 98.5347 105.613 105.585C98.5628 112.635 87.1324 112.635 80.0823 105.585C73.0323 98.5347 73.0323 87.1043 80.0823 80.0542C87.1324 73.0042 98.5628 73.0042 105.613 80.0542ZM80.0825 168.251C87.1326 175.301 98.563 175.301 105.613 168.251C112.663 161.201 112.663 149.77 105.613 142.72C98.563 135.67 87.1326 135.67 80.0825 142.72C73.0325 149.77 73.0325 161.201 80.0825 168.251ZM142.748 105.585C149.798 112.635 161.229 112.635 168.279 105.585C175.329 98.5349 175.329 87.1045 168.279 80.0545C161.229 73.0044 149.798 73.0044 142.748 80.0544C135.698 87.1045 135.698 98.5349 142.748 105.585ZM168.279 168.251C175.329 161.2 175.329 149.77 168.279 142.72C161.229 135.67 149.798 135.67 142.748 142.72C135.698 149.77 135.698 161.2 142.748 168.251C149.798 175.301 161.229 175.301 168.279 168.251Z"
      fill="currentColor"
    />
  </svg>
);

export const BerryAI = ({ width = '24px', height = '24px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.82318 5.01999C4.70291 5.05507 4.55006 5.22045 4.51498 5.34824C4.46988 5.51863 4.49995 6.3806 4.56259 6.6462C4.68286 7.15737 4.94095 7.651 5.28173 8.01934L5.41955 8.16718L5.26169 8.22481C5.17649 8.25488 5.00109 8.33506 4.87079 8.40272C3.92864 8.89384 3.27214 9.77586 3.04662 10.8558C2.97897 11.1791 2.98649 11.8606 3.05915 12.2014C3.13182 12.5297 3.24207 12.8479 3.37487 13.0985C3.46508 13.2663 4.95849 15.6418 5.4847 16.4486C5.9232 17.1252 6.60476 17.5912 7.39907 17.7616C7.69224 17.8243 8.30615 17.8243 8.59681 17.7616C9.22825 17.6263 9.76197 17.3256 10.198 16.8595C10.3608 16.6841 10.5713 16.3684 11.4508 14.9878C12.0322 14.0732 12.5584 13.2288 12.6185 13.111C12.7588 12.8479 12.8691 12.5347 12.9417 12.2014C13.0194 11.8356 13.0194 11.1791 12.9417 10.8132C12.6811 9.60798 11.8718 8.6558 10.7392 8.22231L10.5864 8.16468L10.7217 8.01684C10.9923 7.72367 11.2303 7.31774 11.3556 6.92685C11.4759 6.556 11.4959 6.39814 11.4959 5.84187V5.32819L11.4283 5.22546C11.3907 5.17033 11.318 5.09767 11.2654 5.06509C11.1727 5.00746 11.1527 5.00495 10.6565 5.00495C10.1028 5.00495 9.94239 5.025 9.57655 5.14527C9.02278 5.32318 8.44146 5.73412 8.12323 6.17012C8.06309 6.25281 8.00796 6.32046 8.00045 6.32046C7.99293 6.32046 7.9378 6.25281 7.87767 6.17012C7.49178 5.6389 6.81774 5.21543 6.10361 5.05256C5.89564 5.00495 4.94847 4.9799 4.82318 5.01999ZM5.97081 6.05485C6.21386 6.1175 6.38926 6.19517 6.5797 6.32046C7.10089 6.65873 7.43165 7.20999 7.49178 7.82891L7.50682 7.9993H7.41661C7.369 7.9993 7.24622 7.98426 7.14349 7.96422C6.24393 7.79132 5.58743 7.06967 5.50224 6.16009L5.4872 5.9872L5.6601 6.00223C5.75532 6.01226 5.89564 6.03481 5.97081 6.05485ZM10.4987 6.1626C10.4385 6.78402 10.1078 7.33277 9.58407 7.67606C9.31595 7.85397 9.00274 7.95921 8.66697 7.99178L8.49408 8.00681L8.50911 7.83392C8.56925 7.19746 8.91504 6.63618 9.44876 6.30292C9.7319 6.12501 10.1153 6.00223 10.4034 5.99722L10.5137 5.99472L10.4987 6.1626ZM10.0927 9.06924C10.6189 9.20956 11.095 9.50775 11.4158 9.89363C12.0597 10.6679 12.1875 11.7328 11.7465 12.6123C11.6388 12.8278 9.63418 15.9851 9.5114 16.1329C9.28589 16.4035 8.87495 16.6591 8.50159 16.7593C8.27107 16.822 7.72231 16.822 7.4993 16.7593C7.10089 16.6466 6.6674 16.3684 6.45692 16.0903C6.39929 16.0151 6.24143 15.7796 6.10612 15.5666C5.97331 15.3536 5.51727 14.637 5.09631 13.9755C4.67785 13.3139 4.29448 12.7 4.24937 12.6098C3.9988 12.1162 3.92864 11.4697 4.06395 10.9185C4.27192 10.0765 4.89084 9.40752 5.72024 9.12938C6.08106 9.0066 6.13869 9.00409 8.07562 9.01161C9.84216 9.01662 9.89728 9.01913 10.0927 9.06924Z"
      fill="white"
    />
    <path
      d="M5.82472 10.5291C5.70444 10.5642 5.55159 10.7296 5.51651 10.8574C5.45888 11.0804 5.54658 11.3134 5.73702 11.4312C5.87984 11.5214 6.1229 11.5164 6.26322 11.4237C6.41857 11.3209 6.48372 11.1981 6.48372 11.0027C6.48372 10.8098 6.41857 10.6845 6.27074 10.5867C6.16299 10.5141 5.95752 10.489 5.82472 10.5291Z"
      fill="white"
    />
    <path
      d="M7.82935 10.5291C7.70908 10.5642 7.55623 10.7296 7.52115 10.8574C7.46352 11.0804 7.55122 11.3134 7.74165 11.4312C7.88448 11.5214 8.12754 11.5164 8.26786 11.4237C8.42321 11.3209 8.48836 11.1981 8.48836 11.0027C8.48836 10.8098 8.42321 10.6845 8.27537 10.5867C8.16763 10.5141 7.96216 10.489 7.82935 10.5291Z"
      fill="white"
    />
    <path
      d="M9.83534 10.5291C9.71506 10.5642 9.56221 10.7296 9.52713 10.8574C9.4695 11.0804 9.5572 11.3134 9.74764 11.4312C9.89046 11.5214 10.1335 11.5164 10.2738 11.4237C10.4292 11.3209 10.4943 11.1981 10.4943 11.0027C10.4943 10.8098 10.4292 10.6845 10.2814 10.5867C10.1736 10.5141 9.96814 10.489 9.83534 10.5291Z"
      fill="white"
    />
    <path
      d="M6.82752 12.5408C6.70725 12.5759 6.5544 12.7413 6.51932 12.8691C6.46169 13.0921 6.54939 13.3251 6.73982 13.4429C6.88265 13.5331 7.12571 13.5281 7.26603 13.4354C7.42138 13.3326 7.48653 13.2099 7.48653 13.0144C7.48653 12.8215 7.42138 12.6962 7.27354 12.5985C7.1658 12.5258 6.96033 12.5007 6.82752 12.5408Z"
      fill="white"
    />
    <path
      d="M8.83265 12.5408C8.71238 12.5759 8.55953 12.7413 8.52445 12.8691C8.46681 13.0921 8.55451 13.3251 8.74495 13.4429C8.88778 13.5331 9.13083 13.5281 9.27115 13.4354C9.42651 13.3326 9.49166 13.2099 9.49166 13.0144C9.49166 12.8215 9.42651 12.6962 9.27867 12.5985C9.17092 12.5258 8.96545 12.5007 8.83265 12.5408Z"
      fill="white"
    />
    <path
      d="M7.82935 14.5408C7.70908 14.5759 7.55623 14.7413 7.52115 14.8691C7.46352 15.0921 7.55122 15.3251 7.74165 15.4429C7.88448 15.5331 8.12754 15.5281 8.26786 15.4354C8.42321 15.3326 8.48836 15.2099 8.48836 15.0144C8.48836 14.8215 8.42321 14.6962 8.27537 14.5985C8.16763 14.5258 7.96216 14.5007 7.82935 14.5408Z"
      fill="white"
    />
    <path
      d="M12.94 17.8086L14.29 13.6086H16.03L17.38 17.8086H16.03L15.85 17.1786H14.47L14.29 17.8086H12.94ZM14.77 16.0986H15.55L15.22 14.9586H15.1L14.77 16.0986ZM18.6484 17.8086V13.6086H19.9084V17.8086H18.6484Z"
      fill="white"
    />
  </svg>
);

export const Report = ({ height = '16px', width = '16px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99927 0.00163917C8.44472 -0.0160402 8.88448 0.109663 9.25362 0.360777C9.49508 0.525036 9.69773 0.737107 9.85021 0.981938H9.95918C10.2623 0.981938 10.553 1.10235 10.7673 1.31667C10.9428 1.49214 11.0553 1.71878 11.0903 1.96152H12.4082C12.8412 1.96152 13.2564 2.13353 13.5626 2.43972C13.8688 2.7459 14.0408 3.16117 14.0408 3.59418V8.49213C14.0408 8.85281 13.7484 9.1452 13.3878 9.1452C13.0271 9.1452 12.7347 8.85281 12.7347 8.49213V3.59418C12.7347 3.50758 12.7003 3.42452 12.6391 3.36328C12.5778 3.30205 12.4948 3.26764 12.4082 3.26764H11.102V4.08398C11.102 4.38709 10.9816 4.67777 10.7673 4.8921C10.553 5.10643 10.2623 5.22684 9.95918 5.22684H6.04082C5.73771 5.22684 5.44702 5.10643 5.23269 4.8921C5.01837 4.67777 4.89796 4.38709 4.89796 4.08398V3.26764H3.59184C3.50523 3.26764 3.42218 3.30205 3.36094 3.36328C3.29971 3.42452 3.26531 3.50757 3.26531 3.59418V8.49213C3.26531 8.85281 2.97292 9.1452 2.61224 9.1452C2.25157 9.1452 1.95918 8.85281 1.95918 8.49213V3.59418C1.95918 3.16117 2.13119 2.7459 2.43738 2.43972C2.74356 2.13353 3.15883 1.96152 3.59184 1.96152H4.90968C4.94471 1.71878 5.05723 1.49214 5.23269 1.31667C5.44702 1.10235 5.73771 0.981938 6.04082 0.981938H6.1531C6.30519 0.737804 6.50716 0.526246 6.74776 0.362196C7.11594 0.11117 7.55461 -0.0150083 7.99927 0.00163917ZM6.20408 3.92071H9.79592V2.28806H9.44C9.15819 2.28806 8.90817 2.10729 8.81985 1.83969C8.76621 1.6772 8.66045 1.53695 8.51898 1.44071C8.3775 1.34446 8.20821 1.2976 8.03738 1.3074C8.01297 1.3088 7.9885 1.30882 7.96408 1.30748C7.79355 1.29809 7.62467 1.34514 7.48355 1.44135C7.34244 1.53757 7.23695 1.67759 7.18339 1.83977C7.09504 2.10733 6.84504 2.28806 6.56327 2.28806H6.20408V3.92071ZM5.946 9.1627L7.17724 12.5497C7.23693 12.7186 7.34581 12.8658 7.48993 12.9724C7.63603 13.0805 7.81149 13.1417 7.99313 13.1479C8.17475 13.1541 8.35399 13.1051 8.50717 13.0073C8.65813 12.9109 8.77675 12.7716 8.84788 12.6074L9.99676 10.0224L10.2892 10.608L10.2901 10.6097C10.365 10.7584 10.4797 10.8835 10.6215 10.9708C10.7632 11.0582 10.9264 11.1044 11.0929 11.1044C11.0928 11.1044 11.093 11.1044 11.0929 11.1044H15.3469C15.7076 11.1044 16 10.812 16 10.4513C16 10.0906 15.7076 9.79825 15.3469 9.79825H11.3448L10.7785 8.66462C10.7024 8.51239 10.5847 8.38484 10.4389 8.29695C10.2932 8.20907 10.1255 8.16441 9.95535 8.16817C9.78522 8.17194 9.61965 8.22397 9.47794 8.31821C9.33623 8.41246 9.22423 8.54503 9.15497 8.70048L8.06183 11.16L6.84919 7.82427C6.78912 7.65926 6.68189 7.51521 6.54095 7.41046C6.40001 7.30571 6.23145 7.24458 6.05613 7.23465C5.8808 7.22471 5.70641 7.2664 5.55454 7.35454C5.40276 7.44264 5.28011 7.57329 5.20176 7.73035C5.20172 7.73043 5.20181 7.73026 5.20176 7.73035L4.16811 9.79825H0.653061C0.292385 9.79825 0 10.0906 0 10.4513C0 10.812 0.292385 11.1044 0.653061 11.1044H4.41971C4.41964 11.1044 4.41978 11.1044 4.41971 11.1044C4.58619 11.1044 4.7496 11.0582 4.89134 10.9708C5.03314 10.8835 5.14787 10.7584 5.22272 10.6097L5.2235 10.6081L5.946 9.1627ZM2.61224 11.7574C2.97292 11.7574 3.26531 12.0498 3.26531 12.4105V14.3697C3.26531 14.4563 3.29971 14.5393 3.36094 14.6006C3.42218 14.6618 3.50524 14.6962 3.59184 14.6962H12.4082C12.4948 14.6962 12.5778 14.6618 12.6391 14.6006C12.7003 14.5393 12.7347 14.4563 12.7347 14.3697V12.4105C12.7347 12.0498 13.0271 11.7574 13.3878 11.7574C13.7484 11.7574 14.0408 12.0498 14.0408 12.4105V14.3697C14.0408 14.8027 13.8688 15.218 13.5626 15.5241C13.2564 15.8303 12.8412 16.0023 12.4082 16.0023H3.59184C3.15883 16.0023 2.74356 15.8303 2.43738 15.5241C2.1312 15.218 1.95918 14.8027 1.95918 14.3697V12.4105C1.95918 12.0498 2.25157 11.7574 2.61224 11.7574Z"
      fill="white"
    />
  </svg>
);

export function CameraOn() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7.5C3.89543 7.5 3 8.39543 3 9.5V14.5C3 15.6046 3.89543 16.5 5 16.5H13C14.1046 16.5 15 15.6046 15 14.5V9.5C15 8.39543 14.1046 7.5 13 7.5H5ZM16.5 10.9491C16.5 10.6634 16.6221 10.3914 16.8356 10.2017L19.3356 7.97943C19.9805 7.40618 21 7.86399 21 8.72684V15.2732C21 16.136 19.9805 16.5938 19.3356 16.0206L16.8356 13.7983C16.6221 13.6086 16.5 13.3366 16.5 13.0509V10.9491Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CameraOff() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5303 4.53033C20.8232 4.23744 20.8232 3.76256 20.5303 3.46967C20.2374 3.17678 19.7626 3.17678 19.4697 3.46967L14.6168 8.32252L14.6162 8.32164L6.43781 16.5H6.43934L3.46967 19.4697C3.17678 19.7626 3.17678 20.2374 3.46967 20.5303C3.76256 20.8232 4.23744 20.8232 4.53033 20.5303L8.56066 16.5H13C14.1046 16.5 15 15.6046 15 14.5V10.0607L20.5303 4.53033Z"
        fill="#f63135"
      />
      <path
        d="M13.2949 7.52159C13.1987 7.50737 13.1002 7.5 13 7.5H5C3.89543 7.5 3 8.39543 3 9.5V14.5C3 15.3978 3.59155 16.1574 4.40614 16.4104L13.2949 7.52159Z"
        fill="#f63135"
      />
      <path
        d="M16.5 10.9491C16.5 10.6634 16.6221 10.3914 16.8356 10.2017L19.3356 7.97943C19.9805 7.40618 21 7.86399 21 8.72684V15.2732C21 16.136 19.9805 16.5938 19.3356 16.0206L16.8356 13.7983C16.6221 13.6086 16.5 13.3366 16.5 13.0509V10.9491Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function MicrophoneOn() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C10.3431 3 9 4.34315 9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 4.34315 13.6569 3 12 3ZM7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 13.9175 6.62158 15.4436 7.73826 16.4858C8.67527 17.3603 9.90114 17.8386 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.6417 16.5 9.52867 16.105 8.76174 15.3892C8.00342 14.6814 7.5 13.5825 7.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MicrophoneOff() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C13.5979 3 14.904 4.24928 14.9949 5.8244L9 11.8193V6C9 4.34315 10.3431 3 12 3Z"
        fill="#f63135"
      />
      <path
        d="M15 10.0607L20.5303 4.53033C20.8232 4.23744 20.8232 3.76256 20.5303 3.46967C20.2374 3.17678 19.7626 3.17678 19.4697 3.46967L3.46967 19.4697C3.17678 19.7626 3.17678 20.2374 3.46967 20.5303C3.76256 20.8232 4.23744 20.8232 4.53033 20.5303L8.19557 16.8651C9.05938 17.5005 10.1108 17.8583 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.919 16.5 9.9933 16.2498 9.27382 15.7868L10.476 14.5846C10.9227 14.8486 11.4436 15 12 15C13.6569 15 15 13.6569 15 12V10.0607Z"
        fill="#f63135"
      />
      <path
        d="M7.6111 13.2082C7.53881 12.8415 7.5 12.4394 7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 12.8969 6.13599 13.7082 6.39503 14.4243L7.6111 13.2082Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function Screenshare({ size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M71.8327 27.1667C71.8327 22.1041 67.7286 18 62.666 18H19.6667C14.6041 18 10.5 22.104 10.5 27.1667V52.6343C10.5 57.697 14.604 61.801 19.6667 61.801H29.9162C31.2969 61.801 32.4162 60.6817 32.4162 59.301C32.4162 57.9203 31.2969 56.801 29.9162 56.801H19.6667C17.3655 56.801 15.5 54.9355 15.5 52.6343L15.5 27.1667C15.5 24.8655 17.3655 23 19.6667 23L62.666 23C64.9672 23 66.8327 24.8655 66.8327 27.1667V52.6344C66.8327 54.9355 64.9672 56.801 62.666 56.801H53.6662C52.2855 56.801 51.1662 57.9203 51.1662 59.301C51.1662 60.6817 52.2855 61.801 53.6662 61.801H62.666C67.7286 61.801 71.8327 57.697 71.8327 52.6344V27.1667Z"
        fill="currentColor"
      />
      <path
        d="M27.8589 44.8567C26.6545 46.0611 26.6545 48.0138 27.8589 49.2182C29.0633 50.4225 31.016 50.4225 32.2204 49.2181L38.5208 42.9177V65.7133C38.5208 67.4165 39.9016 68.7973 41.6048 68.7973C43.3081 68.7973 44.6889 67.4165 44.6889 65.7133L44.6889 42.9177L50.9893 49.2181C52.1937 50.4225 54.1464 50.4225 55.3508 49.2181C56.5552 48.0138 56.5552 46.061 55.3508 44.8566L43.7856 33.2914C43.2072 32.713 42.4228 32.3881 41.6048 32.3881C40.7869 32.3881 40.0025 32.713 39.4241 33.2914L27.8589 44.8567Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Leave() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 4.5H14C15.3807 4.5 16.5 5.61929 16.5 7V10H15V7C15 6.44772 14.5523 6 14 6H7C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H14C14.5523 18 15 17.5523 15 17V14H16.5V17C16.5 18.3807 15.3807 19.5 14 19.5H7C5.61929 19.5 4.5 18.3807 4.5 17V7C4.5 5.61929 5.61929 4.5 7 4.5Z"
        fill="#f63135"
      />
      <path
        d="M19.0303 8.46967C18.7374 8.17678 18.2626 8.17678 17.9697 8.46967C17.6768 8.76256 17.6768 9.23744 17.9697 9.53033L19.6893 11.25H12.75C12.3358 11.25 12 11.5858 12 12C12 12.4142 12.3358 12.75 12.75 12.75H19.6893L17.9697 14.4697C17.6768 14.7626 17.6768 15.2374 17.9697 15.5303C18.2626 15.8232 18.7374 15.8232 19.0303 15.5303L22.0303 12.5303C22.3232 12.2374 22.3232 11.7626 22.0303 11.4697L19.0303 8.46967Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function Info() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25Z"
        stroke="#121A24"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0055 9C12.5519 9 13 8.56069 13 8.00578C13 7.43931 12.5519 7 12.0055 7C11.4481 7 11 7.43931 11 8.00578C11 8.56069 11.4481 9 12.0055 9Z"
        fill="#121A24"
      />
      <path
        d="M12 11V16"
        stroke="#121A24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18C16.4183 18 20 14.866 20 11C20 7.13401 16.4183 4 12 4C7.58172 4 4 7.13401 4 11C4 12.4358 4.49404 13.7707 5.3415 14.8815C5.47613 15.1546 5.75357 16.0287 5 17.7364C4.63024 18.4941 4.46711 19 5 19C6.12068 19 6.64893 18.6353 7.19788 18.2563C7.65602 17.9399 8.12858 17.6137 8.97197 17.4812C9.90599 17.8156 10.9284 18 12 18Z"
        fill="#121A24"
      />
    </svg>
  );
}

export function ChatHighlighted() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18C16.4183 18 20 14.866 20 11C20 7.13401 16.4183 4 12 4C7.58172 4 4 7.13401 4 11C4 12.4358 4.49404 13.7707 5.3415 14.8815C5.47613 15.1546 5.75357 16.0287 5 17.7364C4.63024 18.4941 4.46711 19 5 19C6.12068 19 6.64893 18.6353 7.19788 18.2563C7.65602 17.9399 8.12858 17.6137 8.97197 17.4812C9.90599 17.8156 10.9284 18 12 18Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function Arrow() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75V11.25ZM19 12L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L19 12ZM14.5303 6.46967C14.2374 6.17678 13.7626 6.17678 13.4697 6.46967C13.1768 6.76256 13.1768 7.23744 13.4697 7.53033L14.5303 6.46967ZM13.4697 16.4697C13.1768 16.7626 13.1768 17.2374 13.4697 17.5303C13.7626 17.8232 14.2374 17.8232 14.5303 17.5303L13.4697 16.4697ZM5 12.75H19V11.25H5V12.75ZM19.5303 11.4697L14.5303 6.46967L13.4697 7.53033L18.4697 12.5303L19.5303 11.4697ZM18.4697 11.4697L13.4697 16.4697L14.5303 17.5303L19.5303 12.5303L18.4697 11.4697Z"
        fill="#121A24"
      />
    </svg>
  );
}
